import React, { useState, useReducer, useImperativeHandle, forwardRef, useRef } from "react";
import { useEffect } from "react";
import classes from "./CMS.module.css";
import JSZip from 'jszip'
import Player from "../Player/Player";
import Slide from "./Slide";
import NewSlideImg from '../assests/new-slide.png';
import NewSlidePopup from "./NewSlidePopup";
import * as contentTypes from './contentTypes';
import FileEditor from "../ContentsEditor/FileEditor";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import QuestionnaireEditor from "../ContentsEditor/QuestionnaireEditor";
import ImageEditor from "../ContentsEditor/ImageEditor";
import { getExtByType, getFileTypeFromArrayBuffer, getTypeByExt } from "./utils";
import ContentEditor from "../ContentsEditor/ContentEditor";
import { addSlide, deleteLesson, deleteLessonWithoutSlide, deleteSlide, generateStateFromDB, lessonExist, updateOrder, updateSlide } from "./db";
import { uuidv4 } from "./utils";
import viewIcon from '../assests/view.png'
import saveIcon from '../assests/save.png'
import importIcon from '../assests/import.png'
import downloadIcon from '../assests/download.png'
import { useSelector } from "react-redux";
import SwitchToggle from "../../UI/SwitchToggle";


const enumCMSContentTypeEditor = {
    tinyMCE: ContentEditor,
    quetion: QuestionnaireEditor,
    file: FileEditor,
    image: ImageEditor
}


const contentsReducer = (contents, action) => {
    let newState = { ...contents };
    const createCurrentContent = (index, dispatch) => {
        const content = newState.list[index]
        const Component = enumCMSContentTypeEditor[content.type];
        if (!newState.save)
            updateOrder(newState.lessonId, newState.list.map(c => c.id));
        return {
            index: index,
            content: content,
            component: <Component
                {...content}
                index={index}
                setContentData={(data) => dispatch({ type: "CHANGE_CONTENT_DATA", index: index, data: data, dispatch: dispatch })}
                addListOfContents={(list) => dispatch({ type: "ADD_LIST_CONTENT_DATA", newListContent: list, dispatch: dispatch })}></Component>
        }
    }

    const swapContents = (sourceIndex, destinationIndex) => {
        newState.list = [...newState.list];
        // Remove dragged item
        const [reorderedItem] = newState.list.splice(sourceIndex, 1);
        // Add dropped item
        newState.list.splice(destinationIndex, 0, reorderedItem);
    }

    switch (action.type) {
        case 'INIT':
            newState.list = action.contents.map(c => ({ ...c }))
            newState.version = action.version;
            newState.current = createCurrentContent(0, action.dispatch)
            return newState;
        case 'CHANGE_CONTENT_DATA':
            newState.list[action.index] = { ...newState.list[action.index], data: action.data };
            newState.current = createCurrentContent(action.index, action.dispatch);
            newState.save = false;
            return newState;
        case 'ADD_CONTENT_DATA':
            newState.list = [...newState.list, action.newContent];
            newState.current = createCurrentContent(newState.list.length - 1, action.dispatch)
            newState.save = false;
            return newState;
        case 'ADD_LIST_CONTENT_DATA':
            newState.list = [...newState.list, ...action.newListContent];
            newState.current = createCurrentContent(newState.list.length - 1, action.dispatch)
            newState.save = false;
            return newState;
        case 'SET_CONTENT_CURRENT':
            newState.current = createCurrentContent(action.index, action.dispatch);
            return newState;
        case 'SET_CURRENT_CONTENT_NAME':
            newState.list[newState.current.index] = { ...newState.list[newState.current.index], name: action.newName }
            newState.current = createCurrentContent(newState.current.index, action.dispatch)
            newState.save = false;
            return newState;
        case 'OREDR_BY_DARG':
            if (action.destinationIndex !== action.sourceIndex) {
                swapContents(action.sourceIndex, action.destinationIndex)
                if (action.sourceIndex === newState.current.index) {
                    newState.current = createCurrentContent(action.destinationIndex, action.dispatch);
                }
                newState.save = false;
            }
            return newState;
        case 'OREDR_UP':
            if (newState.current.index > 0) {
                swapContents(newState.current.index, newState.current.index - 1)
                newState.current = createCurrentContent(newState.current.index - 1, action.dispatch)
                newState.save = false;
            }
            return newState;
        case 'OREDR_DOWN':
            if (newState.current.index !== newState.list.length - 1) {
                swapContents(newState.current.index, newState.current.index + 1)
                newState.current = createCurrentContent(newState.current.index + 1, action.dispatch)
                newState.save = false;
            }
            return newState;
        case 'DULICATE_CONTENT_DATA':
            newState.list = [...newState.list]
            newState.list.splice(newState.current.index + 1, 0, action.sourceContent);
            newState.current = createCurrentContent(newState.current.index + 1, action.dispatch)
            newState.save = false;
            return newState;
        case 'DELETE_CONTENT_DATA':
            newState.list = [...newState.list];
            newState.list.splice(newState.current.index, 1);
            newState.current = newState.current.index === 0 ?
                newState.list.length > 0 ? createCurrentContent(0, action.dispatch) : null :
                createCurrentContent(newState.current.index - 1, action.dispatch)
            newState.save = false;
            return newState;
        case 'SET_SAVE':
            newState.save = action.save
            return newState;
        case 'SET_VERSION':
            newState.version = action.version;
            newState.save = false;
            return newState
        default:
            throw new Error('Should not get there')
    }
};

const CMS = forwardRef(({ materialContentPath = '', saveFile, setTempCMSStatus, lessonId, studyGroupId }, ref) => {

    const { texts, direction } = useSelector(state => state.translate);

    const [showPreview, setShowPreview] = useState();
    const [showNewSlidePopup, setShowNewSlidePopup] = useState();
    const [load, setLoad] = useState(!!materialContentPath);
    const [contents, dispatch] = useReducer(contentsReducer, {
        list: [],
        current: {
            index: 0, component: <div>{texts.startWithCms}</div>
        },
        save: true,
        lessonId: lessonId
    });
    const contentsRef = useRef(contents);
    let firstAlert = true;
    const { isAdmin } = useSelector(state => state.auth);

    // create contents to edit mode from meta json 
    useEffect(() => {
        (async () => {
            let advancedVersionExist = await lessonExist(lessonId);
            let restore = false;
            if (advancedVersionExist) {
                restore = window.confirm(texts.retoreUnSavedChanges);
            }
            if (restore) {
                await restoreContents();
                setLoad(false);
            }
            else if (materialContentPath) {
                setLoad(true)
                let notCacheNumber = Math.floor(new Date().getTime());
                const pdfs = {};
                let mataData = await fetch(`${materialContentPath}meta.json?notCacheNumber=${notCacheNumber}`);
                mataData = await mataData.json();

                const fetchFile = async (name) => {
                    try {
                        let res = await fetch(name);
                        return res;
                    }
                    catch (e) {
                        return null;
                    }
                }
                const createBlobfromUrl = async (url) => {
                    if (url) {
                        try {
                            let res = await fetchFile(url);
                            const contentType = res.headers.get('Content-Type');
                            if (res && res.ok) {
                                const blobFile = await res.blob(({ type: contentType }));
                                const blobUrl = URL.createObjectURL(blobFile);
                                return blobUrl;
                            }
                        }
                        catch (e) {
                            return null;
                        }
                    }
                    return null;
                }

                const replaceWithBlobsSrcsInHTMLText = async (html) => {
                    const doc = document.implementation.createHTMLDocument("New Document");

                    if (html !== "undefined")
                        doc.body.innerHTML = html.replaceAll("#BASE_PATH_REPLACE#", materialContentPath);;
                    const imgs = doc.getElementsByTagName("img");
                    for (let index = 0; index < imgs.length; index++) {
                        const img = imgs[index];
                        const parts = img.src.split(".");
                        const extension = parts[parts.length - 1];
                        if (extension === "undefined" && firstAlert && isAdmin) {
                            alert("בשיעור זה יש תמונות תקולות. במקרה שהן נעלמות באפשרותך ליצא וליבא את השיעור כדי לתקן את התמונות")
                            firstAlert = false
                        }
                        const newUrl = await createBlobfromUrl(img.src);
                        img.src = newUrl;
                    }

                    const videos = doc.getElementsByTagName("video");
                    for (let index = 0; index < videos.length; index++) {
                        const video = videos[index];
                        const videoSource = video.getElementsByTagName("source")[0]
                        const newUrl = await createBlobfromUrl(videoSource.src);
                        videoSource.src = newUrl;
                    }

                    const bgImages = doc.querySelectorAll("span[data-background]");

                    for (let index = 0; index < bgImages.length; index++) {
                        const bgImage = bgImages[index];
                        // const url = bgImage.style.backgroundImage.slice(4, -1).replace(/"/g, "");
                        const url = bgImage.getAttribute('data-background-url')
                        const newUrl = await createBlobfromUrl(url);
                        bgImage.style.backgroundImage = `url(${newUrl})`;
                        bgImage.setAttribute('data-background-url', newUrl)
                    }

                    return doc.body.innerHTML;
                }

                for (let i = 0; i < mataData.contents.length; i++) {
                    const content = mataData.contents[i];
                    switch (content.type) {
                        case contentTypes.tinyMCE:
                            try {
                                const fileContent = await fetchFile(`${materialContentPath}${content.data.html}`)
                                const fileContentText = await fileContent.text();
                                const fileContentTextBlobs = await replaceWithBlobsSrcsInHTMLText(fileContentText);
                                content.data.html = fileContentTextBlobs
                                if (content.data.bgImage && content.data.bgImage.url) {
                                    const bgImageBlobUrl = await createBlobfromUrl(`${materialContentPath}${content.data.bgImage.url}`);
                                    content.data.bgImage.url = bgImageBlobUrl;
                                }
                                if (content.data.video && content.data.video.url) {
                                    const videoBlobUrl = content.data.video.isFile ? await createBlobfromUrl(`${materialContentPath}${content.data.video.url}`) : content.data.video.url;
                                    content.data.video.url = videoBlobUrl;
                                }
                            }
                            catch {

                            }
                            break;
                        case contentTypes.file:
                            let tempUrl;
                            if (pdfs[content.data.url]) {
                                tempUrl = pdfs[content.data.url]
                            }
                            else {
                                tempUrl = await createBlobfromUrl(`${materialContentPath}${content.data.url}`)
                                pdfs[content.data.url] = tempUrl;
                            }

                            content.data.url = tempUrl
                            break;
                        case contentTypes.quetion:
                            if (content.data.bgImage && content.data.bgImage.url) {
                                const bgImageBlobUrl = await createBlobfromUrl(`${materialContentPath}${content.data.bgImage.url}`);
                                content.data.bgImage.url = bgImageBlobUrl;
                            }
                            if (content.data.video && content.data.video.url) {
                                const videoBlobUrl = content.data.video.isFile ? await createBlobfromUrl(`${materialContentPath}${content.data.video.url}`) : content.data.video.url;
                                content.data.video.url = videoBlobUrl;
                            }
                            for (let index = 0; index < content.data.quetions.length; index++) {
                                const quetion = content.data.quetions[index];
                                const name = await replaceWithBlobsSrcsInHTMLText(quetion.name);
                                quetion.name = name;
                                switch (quetion.type) {
                                    case "options":
                                        for (let optIndex = 0; optIndex < quetion.data.options.length; optIndex++) {
                                            const opt = quetion.data.options[optIndex];
                                            opt.content = await replaceWithBlobsSrcsInHTMLText(opt.content)
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                            break;
                        case contentTypes.image:
                            if (content.data.url) {
                                const imageTempUrl = await createBlobfromUrl(`${materialContentPath}${content.data.url}`)
                                if (imageTempUrl)
                                    content.data.url = imageTempUrl
                            }
                            break;
                        default:
                            break;
                    }
                    addSlide({ ...content, lessonId: lessonId });
                }
                if (mataData.contents.length > 0)
                    dispatch({ type: 'INIT', contents: mataData.contents, version: mataData.version ? mataData.version : 1, dispatch: dispatch })
                setLoad(false);
            }
            else {
                dispatch({ type: 'SET_VERSION', version: 2 })
            }

        })()
    }, [])

    // alert when user exit from page  with changes that dont save 
    useEffect(() => {
        const handleBeforeUnLoad = (e) => {
            e.preventDefault();
            return e.returnValue = "Are you sure you want to exit?";
        }
        if (!contents.save) {
            window.addEventListener("beforeunload", handleBeforeUnLoad);
        }
        else {
            window.removeEventListener("beforeunload", handleBeforeUnLoad);
        }
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnLoad);
        }
    }, [contents]);

    useEffect(() => {
        contentsRef.current = contents;
        setTempCMSStatus(contents.save)
    }, [contents])

    useEffect(() => {
        return () => {
            (async () => {
                console.log("cms unload")
                if (contentsRef.current && contentsRef.current.save) {
                    deleteLesson(contentsRef.current.lessonId);
                }
            })()
        }
    }, [])

    const handleSave = async (deleteWithoutSlide = false) => {
        if (!contents.save) {
            const file = await generatePackage(contents);
            let sucsses = await saveFile(file);
            if (sucsses) {
                dispatch({ type: "SET_SAVE", save: true })
                if (deleteWithoutSlide) {
                    await deleteLessonWithoutSlide(lessonId);
                }
                else {
                    await deleteLesson(lessonId);
                }
            }
        }
        else {
            await deleteLesson(lessonId);
        }

    }

    useImperativeHandle(ref, () => ({
        save: handleSave
    }))

    const generatePreviewBlobsLink = () => {
        const meta = {}
        meta.editorWidth = 1021;
        meta.editorHeight = 574;
        meta.proportion = 574 / 1021;
        meta.contents = [];
        meta.version = contents.version;
        for (let i = 0; i < contents.list.length; i++) {
            const content = contents.list[i];
            switch (content.type) {
                case contentTypes.tinyMCE:
                    const htmlBlob = new Blob([content.data.html], { type: 'text/html' })
                    const url = URL.createObjectURL(htmlBlob);
                    meta.contents.push({
                        id: content.id,
                        name: content.name,
                        type: content.type,
                        data: { ...content.data, html: url }
                    })
                    break;
                case contentTypes.file:
                    meta.contents.push({
                        id: content.id,
                        name: content.name,
                        type: content.type,
                        data: content.data
                    })
                    break;
                case contentTypes.quetion:
                    meta.contents.push({
                        id: content.id,
                        name: content.name,
                        type: content.type,
                        data: content.data
                    })
                    break;
                case contentTypes.image:
                    meta.contents.push({
                        id: content.id,
                        name: content.name,
                        type: content.type,
                        data: content.data
                    })
                    break;
                default:
                    break;
            }
        }
        const metaBlob = new Blob([JSON.stringify(meta)], { type: 'application/json' })
        const metaUrl = URL.createObjectURL(metaBlob);
        return metaUrl
    }

    const generatePackage = async (contentsList) => {
        const meta = {}
        meta.editorWidth = 1021;
        meta.editorHeight = 574;
        meta.proportion = 574 / 1021;
        meta.lessonId = lessonId;
        meta.version = contents.version
        meta.contents = []
        const zip = new JSZip();
        const duplicatePdf = {};
        const addBlobFileToZip = async (blobUrl) => {
            if (blobUrl && (blobUrl.startsWith("data:image") || blobUrl.startsWith("blob:"))) {
                try {
                    const blob = await fetch(blobUrl).then(r => r.blob())
                    const ext = getExtByType(blob.type)
                    const fileUrl = `${uuidv4()}.${ext}`;
                    zip.file(fileUrl, blob);
                    return fileUrl;
                }
                catch (e) {
                    return null
                }
            }
        }

        const replaceAndSaveSrcsInHTMLText = async (html) => {
            const doc = document.implementation.createHTMLDocument("New Document");
            doc.body.innerHTML = html;
            const imgs = doc.getElementsByTagName("img");
            for (let index = 0; index < imgs.length; index++) {
                const img = imgs[index];
                let ext = img.alt.split(".").pop();
                const newUrl = await addBlobFileToZip(img.src, ext);
                if (newUrl)
                    img.src = `#BASE_PATH_REPLACE#${newUrl}`
            }

            const videos = doc.getElementsByTagName("video");
            for (let index = 0; index < videos.length; index++) {
                const video = videos[index];
                const videoSource = video.getElementsByTagName("source")[0]
                const newUrl = await addBlobFileToZip(videoSource.src);
                if (newUrl)
                    videoSource.src = `#BASE_PATH_REPLACE#${newUrl}`
            }

            const bgImages = doc.querySelectorAll("span[data-background],body[data-background]");

            for (let index = 0; index < bgImages.length; index++) {
                const bgImage = bgImages[index];
                const url = bgImage.getAttribute('data-background-url')
                const newUrl = await addBlobFileToZip(url);
                if (newUrl) {
                    bgImage.style.backgroundImage = `url(#BASE_PATH_REPLACE#${newUrl})`
                    bgImage.setAttribute('data-background-url', `#BASE_PATH_REPLACE#${newUrl}`)

                }

            }

            return doc.body.innerHTML;
        }

        for (let i = 0; i < contentsList.list.length; i++) {
            const content = { ...contentsList.list[i] };
            switch (content.type) {
                case contentTypes.tinyMCE:
                    if (content.data.bgImage && content.data.bgImage.url) {
                        const bgImageUrl = await addBlobFileToZip(content.data.bgImage.url)
                        if (bgImageUrl)
                            content.data = { ...content.data, bgImage: { ...content.data.bgImage, url: bgImageUrl } }
                    }
                    if (content.data.video && content.data.video.url) {
                        const videoUrl = await addBlobFileToZip(content.data.video.url)
                        if (videoUrl)
                            content.data = { ...content.data, video: { ...content.data.video, url: videoUrl } }
                    }

                    const fileContent = await replaceAndSaveSrcsInHTMLText((content.data.html !== undefined && content.data.html !== "") ? content.data.html : undefined);
                    const fileName = `${uuidv4()}.html`;
                    meta.contents.push({
                        name: content.name,
                        type: content.type,
                        id: content.id,
                        data: { ...content.data, html: fileName }
                    })
                    zip.file(fileName, fileContent);
                    break;
                case contentTypes.file:
                    let url;
                    if (duplicatePdf[content.data.url]) {
                        url = duplicatePdf[content.data.url];
                    }
                    else {
                        url = await addBlobFileToZip(content.data.url);
                        duplicatePdf[content.data.url] = url;
                    }
                    if (url)
                        content.data = { ...content.data, url: url }
                    meta.contents.push({
                        name: content.name,
                        type: content.type,
                        id: content.id,
                        data: content.data
                    })
                    break;
                case contentTypes.quetion:

                    if (content.data.bgImage && content.data.bgImage.url) {
                        const bgImageUrl = await addBlobFileToZip(content.data.bgImage.url)
                        if (bgImageUrl)
                            content.data = { ...content.data, bgImage: { ...content.data.bgImage, url: bgImageUrl } }
                    }
                    if (content.data.video && content.data.video.url) {
                        const videoUrl = await addBlobFileToZip(content.data.video.url)
                        if (videoUrl)
                            content.data = { ...content.data, video: { ...content.data.video, url: videoUrl } }
                    }
                    const quetions = [...content.data.quetions]
                    for (let index = 0; index < quetions.length; index++) {
                        const quetion = { ...quetions[index] };
                        const name = await replaceAndSaveSrcsInHTMLText(quetion.name);
                        quetion.name = name;
                        switch (quetion.type) {
                            case "options":
                                let options = [...quetion.data.options]
                                for (let optIndex = 0; optIndex < options.length; optIndex++) {
                                    const opt = { ...options[optIndex] };
                                    opt.content = await replaceAndSaveSrcsInHTMLText(opt.content)
                                    options[optIndex] = opt;
                                }
                                quetion.data = { ...quetion.data, options: options };
                                break;
                            default:
                                break;
                        }
                        quetions[index] = quetion
                    }
                    content.data = { ...content.data, quetions: quetions }
                    meta.contents.push({
                        name: content.name,
                        type: content.type,
                        id: content.id,
                        data: content.data
                    })
                    break;
                case contentTypes.image:
                    const imageUrl = await addBlobFileToZip(content.data.url)
                    if (imageUrl)
                        content.data = { ...content.data, url: imageUrl }
                    meta.contents.push({
                        name: content.name,
                        type: content.type,
                        id: content.id,
                        data: content.data
                    })
                    break;
                default:
                    break;
            }
        }

        zip.file("meta.json", JSON.stringify(meta));

        const zipfile = await zip.generateAsync({
            type: 'blob',
            compression: 'DEFLATE',
            compressionOptions: { level: 6 }
        });


        // temp download instead of send api 

        return zipfile;
    }

    const download = async () => {

        let zipfile = await generatePackage(contents);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        const url = window.URL.createObjectURL(zipfile);
        a.href = url;
        a.download = `lesson.zip`;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }

    const handleCreateNewSlide = async (type) => {
        const newContent = {
            type: type,
            name: "",
            data: '',
            id: uuidv4(),
        }
        if (contents.current && contents.current.content) {
            updateSlide(contents.current.content.id, { ...contents.current.content })
        }
        addSlide({ ...newContent, lessonId: lessonId });
        dispatch({ type: "ADD_CONTENT_DATA", newContent: newContent, dispatch: dispatch })
    }

    const handleDeleteSlide = () => {
        deleteSlide(contents.current.content.id)
        dispatch({ type: 'DELETE_CONTENT_DATA', dispatch: dispatch })
    }

    const selectSlide = (i) => {
        updateSlide(contents.current.content.id, { ...contents.current.content })
        dispatch({ type: "SET_CONTENT_CURRENT", dispatch: dispatch, index: i })
    }

    const orderUP = () => {
        dispatch({ type: 'OREDR_UP', dispatch: dispatch })
    }

    const orderDown = () => {
        dispatch({ type: 'OREDR_DOWN', dispatch: dispatch })
    }

    const duplicate = async () => {
        const source = contents.current;
        const duplicateId = uuidv4();

        const sourceContent = { ...contents.list[source.index], id: duplicateId };
        if (sourceContent.type === contentTypes.quetion) {
            if (sourceContent.data && sourceContent.data.quetions && sourceContent.data.quetions.length > 0) {
                sourceContent.data = { ...sourceContent.data }
                sourceContent.data.quetions = sourceContent.data.quetions.map(q => ({ ...q, id: uuidv4() }))
            }
        }
        dispatch({ type: 'DULICATE_CONTENT_DATA', dispatch: dispatch, sourceContent: sourceContent });
        await updateSlide(source.content.id, { ...source.content });
        await addSlide({ id: duplicateId, lessonId: lessonId, ...sourceContent })
    }

    const handleDrop = (droppedItem) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        dispatch({ type: 'OREDR_BY_DARG', sourceIndex: droppedItem.source.index, destinationIndex: droppedItem.destination.index, dispatch: dispatch });

    };

    const restoreContents = async () => {
        const contents = await generateStateFromDB(lessonId);
        if (contents.length > 0)
            dispatch({ type: 'INIT', contents: contents, dispatch: dispatch });
        dispatch({ type: "SET_SAVE", save: false });

    }

    const importFromZip = async () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');

        input.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (file.type) {
                const pdfs = {};
                const zip = new JSZip();
                var fileReader = new FileReader();
                fileReader.onload = async function (event) {
                    try {
                        setLoad(true);
                        const arrayBuffer = event.target.result;
                        await deleteLesson(lessonId);
                        await zip.loadAsync(arrayBuffer);
                        let metaFile = await zip.file("meta.json").async("text");
                        let mataData = JSON.parse(metaFile);
                        let isCurrentLesson = mataData.lessonId === lessonId;
                        const fetchFile = async (url) => {
                            try {
                                const parts = url.split(".");
                                const extension = parts[parts.length - 1];
                                let type
                                let arrayBuffer = await zip.file(url).async("arraybuffer");
                                if (extension && extension != "undefined")
                                    type = getTypeByExt(extension)
                                else
                                    type = getFileTypeFromArrayBuffer(arrayBuffer)
                                let res = new Blob([arrayBuffer], { type });
                                return res;
                            }
                            catch (e) {
                                return null
                            }
                        }

                        const createBlobfromUrl = async (url) => {
                            try {
                                let blobFile = await fetchFile(url);
                                if (blobFile) {
                                    const blobUrl = URL.createObjectURL(blobFile);
                                    return blobUrl;
                                }
                            }
                            catch (e) {
                                return null
                            }
                        }

                        const replaceWithBlobsSrcsInHTMLText = async (html) => {
                            const doc = document.implementation.createHTMLDocument("New Document");
                            doc.body.innerHTML = html;
                            const imgs = doc.getElementsByTagName("img");
                            for (let index = 0; index < imgs.length; index++) {
                                const img = imgs[index];
                                const newUrl = await createBlobfromUrl(img.src.split('#')[2]);
                                img.src = newUrl;
                            }

                            const videos = doc.getElementsByTagName("video");
                            for (let index = 0; index < videos.length; index++) {
                                const video = videos[index];
                                const videoSource = video.getElementsByTagName("source")[0]
                                const newUrl = await createBlobfromUrl(videoSource.src);
                                videoSource.src = newUrl;
                            }

                            const bgImages = doc.querySelectorAll("span[data-background]");

                            for (let index = 0; index < bgImages.length; index++) {
                                const bgImage = bgImages[index];
                                // const url = bgImage.style.backgroundImage.slice(4, -1).replace(/"/g, "");
                                const url = bgImage.getAttribute('data-background-url')
                                const newUrl = await createBlobfromUrl(url);
                                bgImage.style.backgroundImage = `url(${newUrl})`;
                                bgImage.setAttribute('data-background-url', newUrl)
                            }

                            return doc.body.innerHTML;
                        }
                        const fixDuplicateQuestionIdError = {};
                        for (let i = 0; i < mataData.contents.length; i++) {
                            const content = mataData.contents[i];
                            switch (content.type) {
                                case contentTypes.tinyMCE:
                                    try {
                                        const fileContent = await fetchFile(`${content.data.html}`)
                                        const fileContentText = await fileContent.text();
                                        const fileContentTextBlobs = await replaceWithBlobsSrcsInHTMLText(fileContentText);
                                        content.data.html = fileContentTextBlobs
                                        if (content.data.bgImage && content.data.bgImage.url) {
                                            const bgImageBlobUrl = await createBlobfromUrl(`${content.data.bgImage.url}`);
                                            content.data.bgImage.url = bgImageBlobUrl;
                                        }
                                        if (content.data.video && content.data.video.url) {
                                            const videoBlobUrl = content.data.video.isFile ? await createBlobfromUrl(`${content.data.video.url}`) : content.data.video.url;
                                            content.data.video.url = videoBlobUrl;
                                        }
                                    }
                                    catch (e) {

                                    }
                                    break;
                                case contentTypes.file:
                                    let tempUrl;
                                    if (pdfs[content.data.url]) {
                                        tempUrl = pdfs[content.data.url]
                                    }
                                    else {
                                        tempUrl = await createBlobfromUrl(`${content.data.url}`)
                                        pdfs[content.data.url] = tempUrl;
                                    }

                                    content.data.url = tempUrl
                                    break;
                                case contentTypes.quetion:
                                    if (content.data.bgImage && content.data.bgImage.url) {
                                        const bgImageBlobUrl = await createBlobfromUrl(`${content.data.bgImage.url}`);
                                        content.data.bgImage.url = bgImageBlobUrl;
                                    }
                                    if (content.data.video && content.data.video.url) {
                                        const videoBlobUrl = content.data.video.isFile ? await createBlobfromUrl(`${content.data.video.url}`) : content.data.video.url;
                                        content.data.video.url = videoBlobUrl;
                                    }
                                    for (let index = 0; index < content.data.quetions.length; index++) {
                                        const quetion = content.data.quetions[index];
                                        const name = await replaceWithBlobsSrcsInHTMLText(quetion.name);
                                        quetion.name = name;
                                        if (!isCurrentLesson) {
                                            quetion.id = uuidv4();
                                        }
                                        else {
                                            if (fixDuplicateQuestionIdError[quetion.id]) {
                                                quetion.id = uuidv4();
                                            }
                                            fixDuplicateQuestionIdError[quetion.id] = true;
                                        }
                                        switch (quetion.type) {
                                            case "options":
                                                for (let optIndex = 0; optIndex < quetion.data.options.length; optIndex++) {
                                                    const opt = quetion.data.options[optIndex];
                                                    opt.content = await replaceWithBlobsSrcsInHTMLText(opt.content)
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                    break;
                                case contentTypes.image:
                                    if (content.data.url) {
                                        const imageTempUrl = await createBlobfromUrl(`${content.data.url}`)
                                        content.data.url = imageTempUrl
                                    }

                                    break;
                                default:
                                    break;
                            }
                            addSlide({ ...content, lessonId: lessonId });
                        }
                        if (mataData.contents.length > 0) {
                            dispatch({ type: 'INIT', contents: mataData.contents, dispatch: dispatch })
                            dispatch({ type: "SET_SAVE", save: false })
                        }
                        setLoad(false);
                    }
                    catch (e) {
                        alert(texts.errorOccuredTryAgainLater)
                        setLoad(false)
                    }
                };
                fileReader.readAsArrayBuffer(file);

            }
            else {
                alert(texts.fileNotSupported)
            }
        });
        input.click();
    }

    // const handleOnKeyDown = (e) => {
    //     if (e.ctrlKey && e.key === 's') {
    //         e.preventDefault();
    //         console.log('CTRL + S');
    //         if (contents.list && contents.list.length > 0) {
    //             handleSave();
    //         }
    //     }
    // }
    return <DragDropContext onDragEnd={handleDrop}>
        {load ?
            <div className={classes.Loader}></div> :
            <div className={classes.CMS} >
                <div className={classes.CMSEditor}>
                    <div className={classes.ContentsMenu}>
                        <div className={classes.Title}>{texts.lessonCourse}</div>
                        <div className={classes.Actions}>
                            {contents.list && contents.list.length > 0 &&
                                <>
                                    <div className={`${classes.Action} ${classes.ActionDown}`} onClick={orderDown}></div>
                                    <div className={`${classes.Action} ${classes.ActionUP}`} onClick={orderUP}></div>
                                    <div className={`${classes.Action} ${classes.ActionDuplicate}`} onClick={duplicate}></div>
                                    <div className={`${classes.Action} ${classes.ActionDelete}`} onClick={handleDeleteSlide}></div>
                                </>
                            }
                        </div>
                        <div className={classes.ContentList}>
                            <Droppable droppableId="list-container">
                                {(provided) =>
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {contents.list && contents.list.map((content, i) =>
                                            <Draggable draggableId={content.id} key={content.id} index={i}>
                                                {(provided1) =>
                                                    <div
                                                        {...provided1.draggableProps}
                                                        {...provided1.dragHandleProps}
                                                        ref={provided1.innerRef}>
                                                        <Slide
                                                            name={content.name}
                                                            onClick={() => selectSlide(i)}
                                                            key={i}
                                                            type={content.type}
                                                            selected={contents.current && contents.current.index === i}>
                                                            <div className={`${classes.PreviewNum} ${classes.ContentNum}`}>{i + 1}</div>
                                                        </Slide>
                                                    </div>
                                                }
                                            </Draggable>
                                        )
                                        }
                                        {provided.placeholder}
                                    </div>
                                }
                            </Droppable>
                            <Slide bgImage={NewSlideImg} name={texts.newSlide} dropClass={classes.BorderAndShaddow} onClick={() => setShowNewSlidePopup(true)}></Slide>
                        </div>
                    </div>
                    <div className={classes.ContentViewer}>
                        <div className={classes.Header}>
                            <div className={classes.ChooseVersion}>
                                {contents.current && contents.current.content &&
                                    <div className={classes.ContentNameNum}>
                                        <div className={classes.ContentNum}>{contents.current.index + 1}</div>
                                        <div className={classes.ContentName}><input
                                            className={classes.InputEditName}
                                            type={'text'}
                                            value={contents.current.content.name}
                                            onChange={(e) => dispatch({ type: 'SET_CURRENT_CONTENT_NAME', newName: e.target.value, dispatch: dispatch })}></input></div>
                                    </div>}
                                <div className={classes.ChooseVersion}>
                                    <div className={classes.HeaderTitle}>תצוגה חדשה</div>
                                    <SwitchToggle
                                        id={1}
                                        checked={contents.version >= 2}
                                        setChecked={() => dispatch({ type: 'SET_VERSION', version: contents.version >= 2 ? 1 : 2 })} />

                                </div>
                            </div>
                            <div className={classes.HeaderTitle}>SkillZ CMS</div>
                        </div>
                        <div className={classes.Viewer}>
                            {contents.current && contents.current.component}
                        </div>
                    </div>
                </div>
                {contents.list && contents.list.length > 0 && <div className={classes.BtnsWrap}>
                    <img title={texts.viewLesson} src={viewIcon} alt="view" onClick={() => setShowPreview(true)} />
                    <img title={texts.save} src={saveIcon} alt="save" onClick={() => handleSave(true)} />
                    <img title={texts.download} src={downloadIcon} alt="download" onClick={() => download()} />
                    <img title={texts.import} src={importIcon} alt="import" onClick={() => importFromZip()} />

                </div>}
                {showNewSlidePopup && <NewSlidePopup close={() => setShowNewSlidePopup(false)} onCreateNewSlide={handleCreateNewSlide}></NewSlidePopup>}
                {showPreview && <div className={classes.PreviewBackdrop} onClick={() => setShowPreview(false)}>
                    <div className={`${classes[direction]} ${classes.PreviewContent}`}>
                        <Player close={() => setShowPreview(false)} metaPath={generatePreviewBlobsLink()} index={contents.current && contents.current.index}></Player>
                    </div>

                </div>}
            </div>
        }
    </DragDropContext>
})
export default CMS;